import { Component, DestroyRef, EventEmitter, inject, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup } from '@angular/forms';
import { DeviceService } from '../../../../../../services/device.service';
import { InputSelectComponent } from '../../../../../../shared/components/input-select/input-select';
import { DeviceDto } from '../../../../../../types/dtos/device.dto';
import { CreateReportFilterDto, ReportLogOptionsDto } from '../../../../../../types/dtos/reports.dto';
import { InputSelectInterface } from '../../../../../../types/interfaces/input.interface';

@Component({
  selector: 'app-report-measurement',
  imports: [
    InputSelectComponent,
  ],
  templateUrl: './app-report-measurement.html',
  styleUrl: './app-report-measurement.css',
})
export class AppReportMeasurement {
  @Output()
  public reportOptionsChange: EventEmitter<ReportLogOptionsDto> =
    new EventEmitter<ReportLogOptionsDto>();

  public readonly filterForm: FormGroup = new FormGroup({
    deviceSelect: new FormControl(),
  });
  public deviceSelect: InputSelectInterface = {
    formGroup: this.filterForm,
    onInput: (event?: Event) => {
      this._emitReportOptions();
    },
    isTranslated: true,
    label: 'common.fields.device',
    id: 'deviceSelect',
    iconLeft: 'memory',
    options: [],
    virtualScroll: true,
    filter: true,
    showClear: true,
    required: false,
  };
  private readonly _destroyRef: DestroyRef = inject(DestroyRef);

  constructor(
    private readonly _deviceService: DeviceService,
  ) {
  }

  public ngOnInit(): void {
    this._deviceService.devices$
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((data: DeviceDto[]) => {
        this.deviceSelect.options = data.map((device) => ({
          label: device.serial_number ?? device.device_eui,
          value: device.id.toString(),
        }));
      });
  }

  private _emitReportOptions(): void {
    this.reportOptionsChange.emit({
      rows: ['time', 'device_eui', 'data'],
      filter: this._getLogFilter(),
    });
  }

  private _getLogFilter(): CreateReportFilterDto {
    const {
      deviceSelect,
    } = this.filterForm.value;

    return {
      target_id: deviceSelect ? Number(deviceSelect) : undefined,
    };
  }
}
